"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingWidget = void 0;
var react_1 = __importDefault(require("react"));
var LoadingWidget = function () {
    return (react_1.default.createElement("div", { className: "overlay dark mt-2 d-flex justify-content-center", id: "loading" },
        react_1.default.createElement("i", { className: "fas fa-2x fa-sync-alt fa-spin" })));
};
exports.LoadingWidget = LoadingWidget;
